/**
 * Account orders search — debounced AJAX search with year filter and pagination.
 */

const DEBOUNCE_MS = 800;

function getAjaxConfig() {
    if (typeof decolegnoAjax !== 'undefined' && decolegnoAjax.ajax_url) {
        return {
            url: decolegnoAjax.ajax_url,
            nonce: decolegnoAjax.nonce || '',
        };
    }

    return {
        url: typeof ajaxurl !== 'undefined' ? ajaxurl : '/wp-admin/admin-ajax.php',
        nonce: '',
    };
}

document.addEventListener('DOMContentLoaded', () => {
    const form = document.querySelector('.js-account-orders-search');
    if (!form) {
        return;
    }

    const input = form.querySelector('.js-account-orders-search-input');
    const yearSelect = form.querySelector('.js-account-orders-year');
    const results = document.querySelector('.js-account-orders-results');
    const tableWrap = document.querySelector('.js-account-orders-table');
    const paginationWrap = document.querySelector('.js-account-orders-pagination-wrap');
    const emptyWrap = document.querySelector('.js-account-orders-empty');
    const loader = document.querySelector('.js-account-orders-loader');

    if (!input || !yearSelect || !results || !tableWrap || !paginationWrap || !emptyWrap || !loader) {
        return;
    }

    let debounceTimer = null;
    let abortController = null;
    let currentPage = 1;

    function getSearch() {
        return input.value.trim();
    }

    function getYear() {
        // Empty string must stay empty — never fall back to the first year option.
        return (yearSelect.value || '').trim();
    }

    function setLoading(isLoading) {
        results.classList.toggle('is-loading', isLoading);
        form.setAttribute('aria-busy', isLoading ? 'true' : 'false');
        loader.hidden = !isLoading;
        loader.setAttribute('aria-hidden', isLoading ? 'false' : 'true');
    }

    function syncUrl(page = 1) {
        const url = new URL(window.location.href);
        const search = getSearch();
        const year = getYear();

        if (search) {
            url.searchParams.set('orders_search', search);
        }
        if (!search) {
            url.searchParams.delete('orders_search');
        }

        // Keep "Alle jaren" (empty) as-is; do not invent a year.
        if (year) {
            url.searchParams.set('orders_year', year);
        }
        if (!year) {
            url.searchParams.delete('orders_year');
        }

        // Keep pretty WooCommerce page URLs in sync for refresh/share.
        const path = url.pathname.replace(/\/orders\/\d+\/?$/, '/orders/');
        if (page > 1) {
            url.pathname = path.replace(/\/orders\/?$/, `/orders/${page}/`);
        }
        if (page <= 1) {
            url.pathname = path;
        }

        window.history.replaceState({}, '', url.toString());
    }

    function renderResponse(data) {
        // Never overwrite the year dropdown from the AJAX response.
        if (data.has_results) {
            tableWrap.innerHTML = data.html || '';
            tableWrap.hidden = false;
            paginationWrap.innerHTML = data.pagination || '';
            emptyWrap.innerHTML = '';
            emptyWrap.hidden = true;
            return;
        }

        tableWrap.innerHTML = '';
        tableWrap.hidden = true;
        paginationWrap.innerHTML = '';
        emptyWrap.innerHTML = data.empty || '';
        emptyWrap.hidden = false;
    }

    async function fetchOrders(page = 1) {
        currentPage = page;

        if (abortController) {
            abortController.abort();
        }

        const controller = new AbortController();
        abortController = controller;

        const { url, nonce } = getAjaxConfig();
        const body = new FormData();
        body.append('action', 'search_account_orders');
        body.append('security', nonce);
        body.append('page', String(page));
        body.append('search', getSearch());
        body.append('year', getYear());

        setLoading(true);
        syncUrl(page);

        try {
            const response = await fetch(url, {
                method: 'POST',
                body,
                credentials: 'same-origin',
                signal: controller.signal,
            });

            const json = await response.json();
            if (!json || !json.success) {
                return;
            }

            renderResponse(json.data || {});
        } catch (error) {
            if (error && error.name === 'AbortError') {
                return;
            }
        } finally {
            // Only the active request may clear loading; aborted requests leave it on.
            if (abortController === controller) {
                setLoading(false);
            }
        }
    }

    function scheduleFetch(page = 1) {
        if (debounceTimer) {
            clearTimeout(debounceTimer);
        }

        debounceTimer = setTimeout(() => {
            fetchOrders(page);
        }, DEBOUNCE_MS);
    }

    function fetchImmediate(page = 1) {
        if (debounceTimer) {
            clearTimeout(debounceTimer);
            debounceTimer = null;
        }
        fetchOrders(page);
    }

    input.addEventListener('input', () => {
        scheduleFetch(1);
    });

    // Enter in the search field: search immediately (skip remaining debounce).
    form.addEventListener('submit', (event) => {
        event.preventDefault();
        fetchImmediate(1);
    });

    yearSelect.addEventListener('change', () => {
        fetchImmediate(1);
    });

    results.addEventListener('click', (event) => {
        const link = event.target.closest('.js-account-orders-page');
        if (!link) {
            return;
        }

        event.preventDefault();
        const page = parseInt(link.dataset.page || '1', 10);
        if (!page || page === currentPage) {
            return;
        }

        fetchImmediate(page);
    });
});
